import { render, staticRenderFns } from "./BOEPList.html?vue&type=template&id=f6b6a2be&external"
import script from "./BOEPList.ts?vue&type=script&lang=ts&external"
export * from "./BOEPList.ts?vue&type=script&lang=ts&external"
import style0 from "./BOEPList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports